import { ProductPageContainer as ProductPage } from './ProductPageContainer';

export default ProductPage;
export * from './ProductPageContainer';
